/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { ComponentRenderer } from './ComponentRenderer';
import * as AllComponents from './components/buttonComponents';

export const ButtonComponentRenderer = ({ components }) => (
  <ComponentRenderer components={components} allComponents={AllComponents} />
);
